/* Open Cart Drawer */
document.addEventListener("DOMContentLoaded", () => {
  function openCartDrawer() {
    const cartDrawer = document.querySelector(".cart-drawer");
    if (cartDrawer) {
      cartDrawer.setAttribute("open", "");
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("openCart") === "true") {
    openCartDrawer();
  }
});
